import { View, ViewDensity, ViewType } from "@common/types/views/views";
import { ApplyCoaTemplateEntityColumn } from "../apply/applyCoaTemplateEntitySelectionViewConfig";

// Same columns as the apply wizard Select-entities step, but read-only: no left
// checkbox column and no selection highlight (rows navigate to the entity's
// Chart of Accounts via onRowClick).
export const appliedEntitiesDrawerView: View = {
    type: ViewType.CHART_OF_ACCOUNTS_TEMPLATE_APPLY,
    columns: [
        { id: ApplyCoaTemplateEntityColumn.NAME, options: { pin: "left" } },
        { id: ApplyCoaTemplateEntityColumn.APPLIED_AT },
        { id: ApplyCoaTemplateEntityColumn.LAST_UPDATED },
        { id: ApplyCoaTemplateEntityColumn.INDUSTRY },
        { id: ApplyCoaTemplateEntityColumn.BASIS },
        { id: ApplyCoaTemplateEntityColumn.TEAM },
        { id: ApplyCoaTemplateEntityColumn.SERVICES },
        { id: ApplyCoaTemplateEntityColumn.OPEN, options: { pin: "right" } },
    ],
    filters: {},
    options: { selection: false, bulkActions: false, density: ViewDensity.MD },
};
